import { iCustomChannelConnectionData } from "@sdk/conversations/conversations.models";
import { Descriptions, Divider, Spin } from "antd";
import { LoadingIndicatorWithoutSpin } from "components/common/loading-indicator/loading-indicator";
import { SectionHeader } from "components/common/section-header";
import { ConnectionStartWithChatBotConfig } from "components/modules/connections/common-automation-configs/start-with-chat-bot-config";
import { GeneralConnectionConfig } from "components/modules/connections/common-connection-settings/general-connection-config";
import { RoutingPreferencesForm } from "components/modules/connections/common-connection-settings/routing-preferences-form/routing-preferences-form";
import { loadConnectionById } from "store/modules/connections/connections.helpers";
import { selectConnectionById } from "store/modules/connections/connections.selectors";
import { useQueryWithStore } from "store/store.hooks";

export const ManageCustomChannelConnection = ({
  connectionId,
}: {
  connectionId: string;
}) => {
  const { state: connection } = useQueryWithStore(
    selectConnectionById(connectionId),
    loadConnectionById(connectionId)(),
    [connectionId],
    !connectionId,
  );

  const connectionData = connection?.data as iCustomChannelConnectionData;

  return (
    <Spin
      spinning={false}
      indicator={<LoadingIndicatorWithoutSpin />}
      wrapperClassName="flex-1 flex fill-spinner"
    >
      <div className="animated fadeInLeftMin flex flex-col w-full">
        <SectionHeader
          title="Connected Account"
          icon={<i className="ri-plug-line"></i>}
          description="Configure chat routings, chatbots, etc"
        />
        <Divider />

        <Descriptions
          title="Integration Details"
          bordered
          layout="horizontal"
          column={1}
          style={{ maxWidth: 600 }}
        >
          <Descriptions.Item label="Send Message API URL">
            {connectionData?.sendMessageApiUrl}
          </Descriptions.Item>
        </Descriptions>

        <Divider>Chat Routing Settings</Divider>

        <RoutingPreferencesForm connectionId={connectionId} />

        <ConnectionStartWithChatBotConfig connectionId={connectionId!} />

        <GeneralConnectionConfig connectionId={connectionId} withoutHeader />
      </div>
    </Spin>
  );
};
